import React, { Component } from "react";
import { ReactComponent as Logo } from "../../img/logo.svg";

class ORKG_Nav extends Component {

  /** Component Rendering Function **/
  render() {
    return (
      // <StyledLink to="https://www.orkg.org/orkg/" className="mr-4 p-0">
      <div
        style={{
          display: "flex",
          flexFlow: "row nowrap",
          justifyContent: "flex-start"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <div style={{ padding: "10px" }}>
            <a
              className="mr-4 pt-4 mt-4 ml-4"
              href="https://www.orkg.org/orkg/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Logo />
            </a>
            Reproductive number estimates 2019-nCoV (
            <a
              style={{ color: "#e86161" }}
              href="https://www.orkg.org/orkg/comparison/R12251"
              target="_blank"
              rel="noopener noreferrer"
            >
              ORKG comparison
            </a>
            ) Reference Paper :
            <a
              style={{ color: "#e86161" }}
              href="https://doi.org/10.1093/jtm/taaa021"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://doi.org/10.1093/jtm/taaa021
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default ORKG_Nav;
